import React, { useEffect } from "react";
import Ai from "../../../Images/dallas-it-consulting.jpg";
import ScrollMagic from "scrollmagic";

const Itconsulting = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);
  const techConsultingServices = [
    {
      title: "Technology Strategy & Planning",
      description: "Align IT initiatives with long-term business objectives.",
    },
    {
      title: "IT Infrastructure Assessment",
      description: "Analyze current systems to identify gaps, risks, and opportunities.",
    },
    {
      title: "Digital Transformation Consulting",
      description: "Guide your journey toward automation, cloud adoption, and modern systems.",
    },
    {
      title: "Project Management & IT Governance",
      description: "Ensure successful delivery and compliance with best practices.",
    },
    {
      title: "Vendor & Software Evaluation",
      description: "Select and implement the right technologies for your specific needs.",
    },
    {
      title: "Business Continuity & Risk Management",
      description: "Build resilience and prepare for future challenges.",
    },
  ];

  return (
    <div>
      <div>
        <div className="banner-generative" id="triggerPinned">
          <h1>Empowering Your Vision with Smart IT Consulting</h1>
        </div>
        <div className="white-section">
          <div className="about-generative-ai" style={{ padding: "3rem 0" }}>
            <div className="left-content-ai">
              <h1>Strategic Technology Guidance for Smart Business Decisions</h1>
              <p>
                Owision's IT consulting services help organizations navigate complex technology
                landscapes and make confident, strategic decisions. From digital transformation
                roadmaps to optimizing IT infrastructure, we align technology with your vision to
                create measurable value.
              </p>
            </div>
            <div className="right-content-ai">
              <img src={Ai} alt="ai image" style={{ width: "80%" }} />
            </div>
          </div>
          <div className="generative-card-caontainer">
            <h1>Our IT Consulting Capabilities</h1>
            <div className="generative-card-list">
              {techConsultingServices.map((service, index) => (
                <div className="generative-card" key={index}>
                  <h2>{service.title}</h2>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Itconsulting;
